var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-form",
    {
      ref: "form",
      staticClass: "gift_pack_card_config",
      attrs: {
        model: _vm.value.config,
        disabled: _vm.disabled,
        rules: _vm.rules,
      },
    },
    [
      _c(
        "el-form-item",
        { staticClass: "card_type", attrs: { prop: "card_type" } },
        [
          _c("div", { staticClass: "title" }, [_vm._v("选择样式")]),
          _c(
            "div",
            { staticClass: "content" },
            _vm._l(_vm.defaultList, function (item) {
              return _c(
                "div",
                {
                  key: item.card_type,
                  class: [
                    "box",
                    item.card_type == _vm.value.config.card_type && "checked",
                  ],
                  on: {
                    click: function ($event) {
                      return _vm.changeCardType(item)
                    },
                  },
                },
                [
                  _c("el-image", {
                    staticClass: "img",
                    attrs: { fit: "contain", src: item.imageurl },
                  }),
                ],
                1
              )
            }),
            0
          ),
        ]
      ),
      _c(
        "el-form-item",
        {
          staticClass: "exchange_content",
          attrs: { prop: "exchange_content" },
        },
        [
          _c("div", { staticClass: "title" }, [_vm._v("按钮文案")]),
          _c("el-input", {
            attrs: { placeholder: "请输入按钮文案", clearable: "" },
            model: {
              value: _vm.value.config.exchange_content,
              callback: function ($$v) {
                _vm.$set(_vm.value.config, "exchange_content", $$v)
              },
              expression: "value.config.exchange_content",
            },
          }),
        ],
        1
      ),
      _c(
        "el-form-item",
        {
          staticClass: "is_show_expiration_date",
          staticStyle: { "margin-bottom": "5px" },
          attrs: { prop: "is_show_expiration_date" },
        },
        [
          _c("div", { staticClass: "title" }, [_vm._v("是否显示卡片有效期")]),
          _c(
            "el-radio-group",
            {
              model: {
                value: _vm.value.config.is_show_expiration_date,
                callback: function ($$v) {
                  _vm.$set(_vm.value.config, "is_show_expiration_date", $$v)
                },
                expression: "value.config.is_show_expiration_date",
              },
            },
            [
              _c("el-radio", { attrs: { label: "1" } }, [_vm._v("显示")]),
              _c("el-radio", { attrs: { label: "0" } }, [_vm._v("不显示")]),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-form-item",
        {
          staticClass: "margin_top",
          attrs: {
            prop: "margin_top",
            rules: [{ type: "number", message: "间距必须为数字值" }],
          },
        },
        [
          _c("div", [_vm._v(" 与上方组件的间距 ")]),
          _c("el-input", {
            attrs: { placeholder: "请输入间距", clearable: "" },
            model: {
              value: _vm.value.config.margin_top,
              callback: function ($$v) {
                _vm.$set(_vm.value.config, "margin_top", _vm._n($$v))
              },
              expression: "value.config.margin_top",
            },
          }),
        ],
        1
      ),
      _c(
        "el-form-item",
        {
          staticClass: "z_index",
          attrs: {
            prop: "z_index",
            rules: [
              {
                required: true,
                pattern: /^(?:[1-9]|[1-9][0-9])$/,
                message: "请输入1-99之间的整数！",
              },
            ],
          },
        },
        [
          _c("div", [_vm._v(" 层级高度值 ")]),
          _c("el-input", {
            attrs: { placeholder: "请输入层级高度值", clearable: "" },
            model: {
              value: _vm.value.config.z_index,
              callback: function ($$v) {
                _vm.$set(_vm.value.config, "z_index", _vm._n($$v))
              },
              expression: "value.config.z_index",
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }